class AccordionItem extends HTMLElement {
  /** @type {HTMLButtonElement | null} */
  get button() {
    return this.querySelector('[data-accordion-button]');
  }

  /** @type {HTMLElement | null} */
  get body() {
    return this.querySelector('[data-accordion-body]');
  }

  /** @type {HTMLElement | null} */
  get content() {
    return this.querySelector('[data-accordion-content]');
  }

  get #closeOthers() {
    return this.dataset.closeOthers === 'true';
  }

  get #accordionGroup() {
    return this.closest('[data-accordion-group]');
  }

  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    if (this.button) {
      this.button.addEventListener('click', this.#handleClick, { signal });
    }
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  /**
   * Handles the click event.
   * @param {Event} event - The event.
   */
  #handleClick = (event) => {
    event.preventDefault();

    const isOpen = this.hasAttribute('data-open');

    // Close other accordions if needed
    if (this.#closeOthers && !isOpen) {
      this.#closeOtherAccordions();
    }

    // Toggle current accordion
    if (isOpen) {
      this.close();
    } else {
      this.open();
    }
  };

  /**
   * Closes other accordions in the same group
   */
  #closeOtherAccordions() {
    if (!this.#accordionGroup) return;

    this.#accordionGroup.querySelectorAll('accordion-item').forEach((item) => {
      if (item !== this && item instanceof AccordionItem) {
        item.close();
      }
    });
  }

  /**
   * Opens the accordion
   */
  open() {
    if (!this.body || !this.button) return;

    this.setAttribute('data-open', '');
    this.button.setAttribute('aria-expanded', 'true');
  }

  /**
   * Closes the accordion
   */
  close() {
    if (!this.body || !this.button) return;

    this.removeAttribute('data-open');
    this.button.setAttribute('aria-expanded', 'false');
  }
}

if (!customElements.get('accordion-item')) {
  customElements.define('accordion-item', AccordionItem);
}
